import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { syncTeamWithTookan, getTookanTeams, getTookanErrorLogs } from '../../actions/integration'

import {
  Grid,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
  ListItem,
  Divider,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import moment from 'moment'
import { hasAccess } from '../../utils/api'
import { Appcues } from '../../utils/constants'

class TookanTeamInfoItem extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      tookanTeamInfo: {},
      tookanErrorLogs: [],
    }
  }

  componentDidMount() {
    const { shop = {} } = this.props
    this.props.dispatch(getTookanErrorLogs(shop.id)).then((res) => {
      this.setState({
        tookanErrorLogs: res.values || [],
      })
    })
    this.props.dispatch(getTookanTeams({ shopId: shop.id })).then((res) => {
      this.setState({
        tookanTeamInfo: res || {},
      })
    })
  }

  synchronizeTeam = () => {
    const { shop } = this.props
    this.props.dispatch(syncTeamWithTookan(shop.id)).then((res) => {
      this.props.dispatch(getTookanTeams({ shopId: shop.id })).then((res) => {
        Appcues.track('Team synchronized')
        this.setState({
          tookanTeamInfo: res || {},
        })
      })
    })
  }

  render() {
    const { shop = {}, index, selectedPanel } = this.props
    const { tookanTeamInfo = {}, tookanErrorLogs = [] } = this.state
    const { values = [] } = tookanTeamInfo || {}
    // console.log(values, "values")
    return (
      <ExpansionPanel
        className="margin-top-small"
        expanded={selectedPanel === index}
        onChange={this.props.selectPanel(index)}
      >
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="title" gutterBottom className="tab-heading">
            {shop.name}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div className="full-width">
            {hasAccess() ? (
              <Button
                disabled={!shop.enableTookan}
                className="primary-button pull-right"
                onClick={this.synchronizeTeam}
              >
                Sync Teams
              </Button>
            ) : null}
            {values[0] && (
              <Grid container className="listing-spacing">
                <ListItem>
                  <Grid container>
                    <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                      <Typography>Synchronized Date:</Typography>
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <Typography>
                        {(values[0].syncDate &&
                          moment(values[0].syncDate).format('MMM DD, YYYY')) ||
                          null}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              </Grid>
            )}
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12} className="listing-spacing">
                {values[0] && values[0].tookanTeamInfo && values[0].tookanTeamInfo.length ? (
                  <ListItem>
                    <Typography variant="headline" gutterBottom>
                      Team Info List
                    </Typography>
                  </ListItem>
                ) : null}
                {values[0] &&
                  values[0].tookanTeamInfo &&
                  values[0].tookanTeamInfo.map((teamInfo, i) => {
                    return (
                      <Fragment key={i}>
                        <ListItem>
                          <Grid container>
                            <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                              Team Name
                            </Grid>
                            <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                              {teamInfo.team_name}
                            </Grid>
                          </Grid>
                        </ListItem>
                        <ListItem>
                          <Grid container>
                            <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                              Team ID
                            </Grid>
                            <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                              {teamInfo.team_id}
                            </Grid>
                          </Grid>
                        </ListItem>
                        <Divider />
                      </Fragment>
                    )
                  })}
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12} className="margin-top-small">
                <Typography variant="headline" gutterBottom>
                  Tookan Error Logs
                </Typography>
                <div className="error_log_table">
                  <div className="table-scroll cell-padd-remove">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>TimeStamp</TableCell>
                          <TableCell>Error Cause</TableCell>
                          <TableCell>Sub-Error Cause</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Message</TableCell>
                          <TableCell>Tookan Message</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(tookanErrorLogs &&
                          tookanErrorLogs.length &&
                          tookanErrorLogs.map((errorLog, i) => {
                            return (
                              <TableRow key={i}>
                                <TableCell>
                                  {moment(errorLog.created).format('MM/DD/YYYY hh:mm A')}
                                </TableCell>
                                <TableCell>{errorLog.errorCause}</TableCell>
                                <TableCell>{errorLog.subErrorCause}</TableCell>
                                <TableCell>{errorLog.status}</TableCell>
                                <TableCell>{errorLog.message}</TableCell>
                                <TableCell>{errorLog.tookanMessage}</TableCell>
                              </TableRow>
                            )
                          })) || (
                          <TableRow>
                            <TableCell colSpan={12}>
                              <Typography className="text-center">
                                No Error Logs for this shop.
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    )
  }
}

export default connect(({ dispatch }) => ({ dispatch }))(TookanTeamInfoItem)



// WEBPACK FOOTER //
// ./src/components/Tookan/TookanTeamInfoItem.js